"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledLayout = require("../../StyledLayout");

var _StyledTypography = require("../../StyledTypography");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Elements = require("../Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TitleBox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      width = _ref.width,
      titleMessageId = _ref.titleMessageId,
      titleValues = _ref.titleValues,
      svg = _ref.svg,
      dialog = _ref.dialog,
      secondary = _ref.secondary,
      titleRightContent = _ref.titleRightContent,
      closeButton = _ref.closeButton,
      closeModal = _ref.closeModal,
      scrollState = _ref.scrollState,
      className = _ref.className;
  var showCloseButton = closeButton || !dialog && !secondary;
  return /*#__PURE__*/_react["default"].createElement(_Elements.TitleBoxContainer, {
    scrolled: scrollState,
    size: size,
    width: width,
    svg: svg,
    className: className
  }, showCloseButton && /*#__PURE__*/_react["default"].createElement(_Elements.ModalCloseButton, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    ref: ref,
    ariaLabel: "Close modal",
    onClick: function onClick() {
      return closeModal();
    },
    size: "xs",
    svg: "close",
    stopPropagation: true,
    type: "interactive"
  })), svg && /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    mb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "lg",
    svg: svg
  })), titleMessageId && /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingSmall, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: titleMessageId,
    values: titleValues
  })), titleRightContent && /*#__PURE__*/_react["default"].createElement(_Elements.TitleRightContent, null, titleRightContent));
});
TitleBox.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].string,
  titleMessageId: _propTypes["default"].string,
  titleValues: _propTypes["default"].shape(),
  svg: _propTypes["default"].node,
  dialog: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  titleRightContent: _propTypes["default"].node,
  closeModal: _propTypes["default"].func,
  scrollState: _propTypes["default"].bool,
  className: _propTypes["default"].node,
  closeButton: _propTypes["default"].bool
};
TitleBox.defaultProps = {
  size: '',
  width: '',
  titleValues: null,
  svg: null,
  dialog: null,
  secondary: null,
  titleRightContent: null,
  closeModal: null,
  scrollState: null,
  className: null,
  titleMessageId: null,
  closeButton: false
};
var _default = TitleBox;
exports["default"] = _default;